import dayjs from 'dayjs';
import { urlWithVer } from './redux-query';
import moment from 'moment';

export * from './redux-query';

export const getFullName = (info) =>
  [info?.first || info?.firstName, info?.middle || info?.middleName, info?.last || info?.lastName]
    .filter((s) => s)
    .join(' ');

export const dateToDayjs = (date) => (date ? dayjs(date) : date);

export const dateToStringWT = (date, format = 'MM/DD/YYYY') => {
  if (!date) return '';
  const d = typeof date === 'string' ? dayjs(date) : date;
  return d.format(format);
};

export const dateToString = (date, format = 'MM/DD/YYYY') => {
  if (!date) return '';
  date = removeTimeZonePart(date);
  const d = typeof date === 'string' ? dayjs(date) : date;
  return d.format(format);
};

function removeTimeZonePart(dateString) {
            
  dateString = dateString.toString();
  let finalDate = '';

  if (dateString.includes("T")) {

  let b = dateString.split('T');

  finalDate = b[0];
  } else {
  finalDate = dateString;
  }

  return finalDate;

}

export const getExpires = (day, d = 4) => day?.add(d, 'year').subtract(1, 'day');

/**
 * Calculates the expiry date based on the given start date string.
 *
 * @param {string} dateString - The start date in a valid string format.
 * @param {number} yearsToAdd - Number of years to add to the start date (defaults to 4).
 * @returns {string} - The resulting date in YYYY-MM-DD format.
 */
export const getExpiresFromString = (dateString, yearsToAdd = 4) => {
  if (!dateString) return null; // Return null if dateString is undefined or null

  // Parse the date string into a moment object
  const startDate = moment(dateString, 'MM/DD/YYYY');

  // Check if the parsed date is valid
  if (!startDate.isValid()) return null;

  // Add years and subtract one day
  const expiryDate = startDate.add(yearsToAdd, 'years').subtract(1, 'day');

  // Return the formatted date string
  return expiryDate.format('MM/DD/YYYY');
};

export const getDownloadUrl = (url) => {
  const user = JSON.parse(localStorage.getItem('user-data'));
  return urlWithVer(`${process.env.REACT_APP_API_URL}${url}`, { access_token: user.access_token });
};

export const formatPhoneNumber = (str) => {
  const input = str.replace(/\D/g, '').substring(0, 10);
  const areaCode = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);

  if (input.length > 6) {
    return `(${areaCode}) ${middle}-${last}`;
  }
  if (input.length > 3) {
    return `(${areaCode}) ${middle}`;
  }
  if (input.length > 0) {
    return `(${areaCode}`;
  }
  return '';
};
